var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9451_112676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52699 1.85092L0.230873 14.3485C0.0804442 14.6158 0.000849055 14.9188 6.75527e-06 15.2275C-0.000835544 15.5361 0.0771043 15.8396 0.226072 16.1078C0.37504 16.3759 0.589844 16.5994 0.849112 16.7559C1.10838 16.9125 1.40308 16.9966 1.70388 17H16.2961C16.5969 16.9966 16.8916 16.9125 17.1509 16.7559C17.4102 16.5994 17.625 16.3759 17.7739 16.1078C17.9229 15.8396 18.0008 15.5361 18 15.2275C17.9992 14.9188 17.9196 14.6158 17.7691 14.3485L10.473 1.85092C10.3194 1.59116 10.1032 1.3764 9.84521 1.22735C9.5872 1.0783 9.2961 1 9 1C8.7039 1 8.4128 1.0783 8.15479 1.22735C7.89678 1.3764 7.68056 1.59116 7.52699 1.85092Z",
    fill: "#D4371C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7V9.66667M9 12.6667H9.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9451_112676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning2);
export default __webpack_public_path__ + "static/media/Warning2.919f476854ead022adc86315fb19be3e.svg";
export { ForwardRef as ReactComponent };